import converter from './converter';

export default function (Alpine) {
    Alpine.data('converter', converter);
}
